<template>
  <div class="flex items-end">
    <vs-input
      v-money="money"
      v-model="value"
      icon-pack="feather"
      icon="icon-dollar-sign"
      class="w-full"
      label="Monto máximo permitido"></vs-input>

    <vs-button
        v-if="changed"
        @keyup.enter="updateMaxLoanAmountAllowed"
        @click="updateMaxLoanAmountAllowed"
        class="flex-2 mb-1 ml-2" icon="check"></vs-button>
  </div>
</template>
<script>
import {VMoney} from 'v-money'

export default {
  name: 'ClientMaxLoanAmountAllowedInput',
  props: {
    value: {
      type: Number,
      default: 0
    },
    applicantId: {
      type: Number,
      required: true
    }
  },
  directives: {money: VMoney},
  data () {
    return {
      maxLoanAmountAllowed: 0,
      changed: false,
      money: {
        decimal: '.',
        thousands: ',',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false
      },
    }
  },
  watch: {
    value (val) {
      this.maxLoanAmountAllowed = val
      this.changed = true;
    }
  },
  methods: {
    async updateMaxLoanAmountAllowed () {
      this.$emit('input', this.maxLoanAmountAllowed)
      this.$vs.loading();
      try {
        await axios.put('/api/v1/applicant/' + this.applicantId, {
          max_loan_amount_allowed_mxn: parseFloat(this.maxLoanAmountAllowed.replaceAll(",", ""))
        })
        this.changed = false;
        this.$vs.loading.close();
      } catch (error) {
        console.log(error)
        this.$vs.loading.close();
      }
    }
  }
}
</script>
<style scoped>

</style>